import { BroadcastContentOperationsProps } from './types';

export const WebinarInfoAndControls = ({ children }: BroadcastContentOperationsProps) => <div className="flex-none flex items-center gap-4">{children}</div>;
